import { useState } from 'react';

import { AssignmentGatewayMessage } from '../../../../types/AssignmentGatewayMessage';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { DropdownMenu } from '../../../cdl/DropdownMenu/DropdownMenu';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { DeleteConfirmPopup } from '../../../common/DeleteConfirmPopup/DeleteConfirmPopup';
import { translate } from '../../../common/helpers/translate.helper';
import { useAssignmentDelete } from '../hooks/useAssignmentDelete';

import { EditAssignmentDrawer } from './EditAssignmentDrawer';

interface AssignmentsDropdownProps {
    assignment: AssignmentGatewayMessage;
}

export const AssignmentsDropdown = ({ assignment }: AssignmentsDropdownProps) => {
    const { addToast } = useToasts();
    const { push, pop } = useDrawer();
    const deleteAssignmentMutation = useAssignmentDelete(assignment.id);
    const [deleteAssignmentConfirmationVisible, setDeleteAssignmentConfirmationVisible] = useState(false);

    const handleEditClick = () => {
        const drawerId = push({
            header: { title: translate('assignments.editAssignment') },
            content: <EditAssignmentDrawer assignment={assignment} onSuccess={() => pop(drawerId)} />,
        });
    };

    const options = [
        {
            label: translate('assignments.editAssignment'),
            onSelect: () => {
                handleEditClick();
            },
        },
    ];

    async function handleDeleteAssignment() {
        await deleteAssignmentMutation.mutateAsync();
        setDeleteAssignmentConfirmationVisible(false);
        addToast(translate('assignments.deleteAssignment.deleteSuccess'));
    }

    options.push({
        label: translate('assignments.deleteAssignment.delete'),
        onSelect: () => {
            setDeleteAssignmentConfirmationVisible(true);
        },
    });

    return (
        <div>
            <DropdownMenu align="end" options={options} />
            <DeleteConfirmPopup
                isOpen={deleteAssignmentConfirmationVisible}
                onSubmit={handleDeleteAssignment}
                isSubmitting={deleteAssignmentMutation.isPending}
                onDismiss={() => setDeleteAssignmentConfirmationVisible(false)}
                headline={translate('assignments.deleteAssignment.headline')}
                text={translate('assignments.deleteAssignment.description', {
                    customer: assignment.customer.name,
                    supplier: assignment.supplier.name,
                })}
                deleteButtonText={translate('assignments.deleteAssignment.delete')}
            />
        </div>
    );
};
